import { computed } from 'vue';
import useRwdImg from '@/hooks/useRwdImg';

const playButtonActive = computed(() => useRwdImg('home_pc_play_active', false));
const unlockFrameActive = computed(() => useRwdImg('anniversary_pc_unlock_frame_active', false));

export function useImgSrc() {
  return {
    playButtonActive: playButtonActive.value.imgSrc,
    unlockFrameActive: unlockFrameActive.value.imgSrc,
  }
}
